<template>
  <!-- Page Content -->
  <div class="whole-page-long">
    <div
      class="left-sidebar-front-div"
      v-if="visibleLeft"
      @click="visibleLeft = !visibleLeft"
    ></div>

    <!--contents-->
    <div class="h-100 d-flex flex-column">
      <div class="row f-row h-100">
        <LeftSidebarAdvancedCom
          :selectedAnalysis="pickedAnalysis.toString()"
          :selectedAnalysisParent="''"
          :visibleLeft="visibleLeft"
          @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
          @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
          @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
        />
      </div>

      <div class="largeBox">
        <div class="row f-row h-100 justify-content-center">
          <div class="col col-12 h-100 text-center">
            <div class="no_nav_height">
              <!-- Title -->
              <div class="row f-row mb-2">
                <div
                  class="markets-chart-title col col-12"
                  style="text-align: center!important;"
                >
                  Analysis:
                  <span style="color: var(--textactive); font-size: 1.1rem">
                    {{ selectionStr }}</span
                  >
                </div>
              </div>
              <!-- Company/Portfolio/Asset Selection -->
              <div class="row f-row mb-2">
                <div class="col col-12">
                  <!-- Row: Company/portfolio/spot selector -->
                  <AdvancedSelectors
                    :analytics_preferences="analytics_preferences"
                    :assetReference="assetReference"
                    :assets="assets"
                    :colorTheme="colorTheme"
                    :companies="companies"
                    :currencySpecs="currencySpecs"
                    :confidence="confidence"
                    :contractCommodity="contract"
                    :expandSelectors="expandSelectors"
                    :expoDates="expoDates"
                    :hedgeDates="hedgeDates"
                    :hedgingStats="hedgingStats"
                    :isCurrency="isCurrency"
                    :pastVolatility="pastVolatility"
                    :pickedAnalysis="pickedAnalysis"
                    :pickedBucket="pickedBucket"
                    :pickedIntervalHistory="pickedIntervalHistory"
                    :pickedScenarioVal="pickedScenarioVal"
                    :portfolios="portfolios"
                    :processData="processData"
                    :selectedAsset="selectedAsset"
                    :selectedAssetStr="currencyString"
                    :selectedCompanies="selectedCompanies"
                    :selectedDerivativeDate="selectedDerivativeDate"
                    :selectedExpoDate="selectedExpoDate"
                    :selectedHedgeDate="selectedHedgeDate"
                    :selectedPortfolios="selectedPortfolios"
                    :simRate="simRate"
                    :simsExist="simulations.length > 0"
                    :simUpToDate="simUpToDate"
                    :showAve="showAve"
                    :showBudget="showBudget"
                    :showLoadingSimulating="showLoadingSimulating"
                    :showLoadingSpot="showLoadingSpot"
                    :showSimulations="showSimulations"
                    :showTooltip="showTooltip"
                    :showTooltipDeriv="showTooltipDeriv"
                    :showLoadingVolatility="showLoadingVolatility"
                    :spot="spot"
                    :toBeFetched="toBeFetched"
                    :toBeFetchedHidden="toBeFetchedHidden"
                    @eventOnBucketChange="onBucketChange"
                    @eventOnChangeInterval="onHistoricalIntervalChange"
                    @eventOnChangeToBeFetched="onChangeToBeFetched"
                    @eventOnChangeUserSelection="onChangeUserSelection"
                    @eventOnClientExpandSelectors="onClientExpandSelectors"
                    @eventOnClientShowSims="onClientShowSims"
                    @eventOnPickedScenario="onPickedScenario"
                    @eventOnShow="onShow"
                    @eventOnShowTooltip="onShowTooltip"
                    @eventOnShowTooltipDeriv="onShowTooltipDeriv"
                    @eventOnUserBudgetChange="onUserBudgetChange"
                    @eventOnUserBudgetUpdatedAtChange="
                      onUserBudgetUpdatedAtChange
                    "
                    @eventOnUserConfidence="onUserConfidence"
                    @eventOnUserFetchExpand="onUserFetchExpand"
                    @eventOnUserRestoreSizes="onRestoreSizes"
                    @eventOnUserSelectedDerivativeDate="
                      onUserSelectedDerivativeDate
                    "
                    @eventOnUserSelectExpoDate="onUserSelectExpoDate"
                    @eventOnUserSelectHedgeDate="onUserSelectHedgeDate"
                    @eventOnUserSelection="onUserSelection"
                    @eventOnUserSimRateChange="onUserSimRateChange"
                    @eventOnUserSimulate="onUserSimulate"
                    @eventOnUserSpotChange="onUserSpotChange"
                  />
                </div>
              </div>

              <div class="row f-row container_no_selectors_height_adv">
                <!-- Charts -->
                <div class="row f-row h-100">
                  <Splitter
                    class="col"
                    layout="vertical"
                    v-bind:class="[expandAggregated ? 'col-9' : 'col-12']"
                    @onContext="onContext"
                  >
                    <!-- Chart container 1 -->
                    <SplitterPanel
                      class="row f-row prices_height"
                      :size="chartSizes.sizeSplitterChartPrices"
                      :minSize="4"
                      :style="
                        `flex-basis: ${chartSizes.sizeSplitterChartPrices};`
                      "
                    >
                      <div class="col col-12 no_selectors_height">
                        <div class="row f-row h-100">
                          <div
                            class="col h-100"
                            v-bind:class="[
                              pickedAnalysis !== 1 ? 'col-3' : 'col-12',
                            ]"
                          >
                            <!-- Title 1 -->
                            <div class="row f-row">
                              <div
                                class="chart-title-results text-left d-flex bdr-b"
                              >
                                <span class="mr-auto">
                                  {{
                                    title
                                      ? title.charAt(0).toUpperCase() +
                                        title.slice(1).toLowerCase()
                                      : "..."
                                  }}
                                  rate (<span
                                    style="color: var(--textactive)"
                                    >{{ currencyUnits.rate }}</span
                                  >)
                                </span>
                                <div class="sidebarHidden">
                                  <button
                                    @click="onClientExpandSidebar"
                                    class="btn mr-1"
                                    style="width: 12px;"
                                  >
                                    <span v-if="expandAggregated">&#8594;</span>
                                    <i
                                      class="fa fa-compress"
                                      v-if="!expandAggregated"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!-- Row: Chart Selectors -->
                            <div
                              v-if="pickedAnalysis !== 1"
                              class="row f-row"
                              style="font-size: 0.8rem!important; height: 1rem!important;"
                            >
                              <div
                                class="col col-auto"
                                style="text-align: center;"
                              >
                                <div class="triangle-topleft-active ml-1"></div>
                                <span class="inline-ul"
                                  >&nbsp;Candles Up/Down</span
                                >
                              </div>
                            </div>
                            <!-- Row: Chart -->
                            <HistoricalChart
                              v-if="pickedAnalysis !== 1"
                              :candleData="historicalData"
                              :colorTheme="colorTheme"
                              :dateFormat="dateFormatHist"
                              :minMaxYAxis="minMaxYAxisRates"
                              :renderChartSignal="renderHistorical"
                              :showLoading="
                                showLoadingHistCandles ||
                                  showLoadingHistoricalRatesCalcs
                              "
                              :title="title"
                              :zeroRequests="zeroRequests"
                              :isZoomY="isZoomY"
                              :showSimulations="
                                simulations.length > 0 && showSimulations
                              "
                            />
                            <div v-else class="row f-row h-100">
                              <div class="col col-1 h-100">
                                <RatesChartSelectors
                                  v-if="pickedAnalysis === 1"
                                  :asset="'currencies'"
                                  :fwdName="'Market'"
                                  :isHorizontal="false"
                                  :lCall="lCall"
                                  :lFwd="lFwd"
                                  :lPut="lPut"
                                  :sCall="sCall"
                                  :sFwd="sFwd"
                                  :showAve="showAve"
                                  :showBudget="showBudget"
                                  :showDerivatives="showDerivatives"
                                  :showExpo="showExpo"
                                  :showProtected="showHedge"
                                  :showHedge="showHedge"
                                  :showLCall="showLCall"
                                  :showLFwd="showLFwd"
                                  :showLPut="showLPut"
                                  :showMkt="showMkt"
                                  :showNet="showNet"
                                  :showOHLC="true"
                                  :showSCall="showSCall"
                                  :showSFwd="showSFwd"
                                  :showSPut="showSPut"
                                  :sPut="sPut"
                                  @eventOnShow="onShowPast"
                                  @eventOnShowDerivatives="onShowDerivatives"
                                />
                              </div>
                              <div class="col col-11 h-100">
                                <RatesChart
                                  :asset="'currencies'"
                                  :averages="pastAverages"
                                  :budgetRate="budgetRate"
                                  :candleData="historicalDataSliced"
                                  :chartData="pastChartsDataSliced"
                                  :colorTheme="colorTheme"
                                  :controlsSpace="false"
                                  :currency="currencyUnits"
                                  :dateFormat="dateFormatPast"
                                  :derivativeAverages="derivativeAveragesPast"
                                  :derivativeDateField="derivativeDateField"
                                  :hedgeData="pastHedgeDataSliced"
                                  :historicalData="[]"
                                  :isFuture="true"
                                  :minMaxYAxis="minMaxYAxisPast"
                                  :pickedBucket="'1M'"
                                  :renderChartSignal="renderRateSignal"
                                  :showAve="showAve"
                                  :showExpo="showExpo"
                                  :showHedge="showHedge"
                                  :showLCall="showLCall"
                                  :showLFwd="showLFwd"
                                  :showLoading="
                                    showLoadingTopography ||
                                      showLoadingTopographyCalcsRates ||
                                      showLoadingValuating ||
                                      showLoadingSpot ||
                                      showLoadingAllData
                                  "
                                  :showLPut="showLPut"
                                  :showMkt="showMkt"
                                  :showNet="showNet"
                                  :showProtected="false"
                                  :showSCall="showSCall"
                                  :showSFwd="showSFwd"
                                  :showSimulations="false"
                                  :showSPut="showSPut"
                                  :showTooltip="showTooltip"
                                  :showTooltipDeriv="showTooltipDeriv"
                                  :simulations="[]"
                                  :xRange="
                                    zoomPastXRange.slice(
                                      zoomInitialPast,
                                      zoomFinalPast + 1,
                                    )
                                  "
                                  :zeroRequests="zeroRequests"
                                  :isZoomY="isZoomY"
                                  @onTableFormat="onTableFormat"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col col-9 h-100 results-divider"
                            v-if="pickedAnalysis !== 1"
                          >
                            <!-- Row: Chart Title -->
                            <div class="row f-row">
                              <div
                                class="chart-title-results text-left d-flex bdr-b"
                              >
                                <span class="mr-auto">
                                  Rate (<span
                                    style="color: var(--textactive)"
                                    >{{ currencyUnits.rate }}</span
                                  >)
                                </span>
                                <div class="sidebarHidden">
                                  <button
                                    @click="onClientExpandSidebar"
                                    class="btn mr-1"
                                    style="width: 12px;"
                                  >
                                    <span v-if="expandAggregated">&#8594;</span>
                                    <i
                                      class="fa fa-compress"
                                      v-if="!expandAggregated"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!-- Row: Chart Selectors -->
                            <div
                              v-if="pickedAnalysis !== 1"
                              class="row f-row vert-align"
                            >
                              <RatesChartSelectors
                                :asset="'currencies'"
                                :fwdName="'Market'"
                                :lCall="lCall"
                                :lFwd="lFwd"
                                :lPut="lPut"
                                :sCall="sCall"
                                :sFwd="sFwd"
                                :showAve="showAve"
                                :showBudget="showBudget"
                                :showDerivatives="showDerivatives"
                                :showExpo="showExpo"
                                :showHedge="showHedge"
                                :showLCall="showLCall"
                                :showLFwd="showLFwd"
                                :showLPut="showLPut"
                                :showMkt="showMkt"
                                :showNet="showNet"
                                :showOHLC="false"
                                :showProtected="showHedge"
                                :showSCall="showSCall"
                                :showSFwd="showSFwd"
                                :showSPut="showSPut"
                                :sPut="sPut"
                                @eventOnShow="onShow"
                                @eventOnShowDerivatives="onShowDerivatives"
                              />
                            </div>
                            <RatesChart
                              v-if="pickedAnalysis !== 1"
                              :asset="'currencies'"
                              :averages="averages"
                              :budgetRate="budgetRate"
                              :candleData="[]"
                              :chartData="chartsDataSliced"
                              :colorTheme="colorTheme"
                              :currency="currencyUnits"
                              :dateFormat="dateFormat"
                              :derivativeAverages="derivativeAveragesSliced"
                              :derivativeDateField="derivativeDateField"
                              :hedgeData="hedgeDataSliced"
                              :historicalData="historicalData"
                              :isFuture="false"
                              :minMaxYAxis="minMaxYAxisRates"
                              :pickedBucket="pickedBucket"
                              :renderChartSignal="renderRateSignal"
                              :showAve="showAve"
                              :showExpo="showExpo"
                              :showHedge="showHedge"
                              :showLCall="showLCall"
                              :showLFwd="showLFwd"
                              :showLoading="
                                showLoadingTopography ||
                                  showLoadingTopographyCalcsRates ||
                                  showLoadingValuating ||
                                  showLoadingAllData
                              "
                              :showLPut="showLPut"
                              :showMkt="showMkt"
                              :showNet="showNet"
                              :showProtected="false"
                              :showSCall="showSCall"
                              :showSFwd="showSFwd"
                              :showSimulations="showSimulations"
                              :showSPut="showSPut"
                              :showTooltip="showTooltip"
                              :showTooltipDeriv="showTooltipDeriv"
                              :simulations="simulationsSliced"
                              :xRange="xRange.slice(zoomInitial, zoomFinal + 2)"
                              :zeroRequests="zeroRequests"
                              :isZoomY="isZoomY"
                              @onTableFormat="onTableFormat"
                            />
                          </div>
                        </div>
                      </div>
                    </SplitterPanel>
                    <SplitterGutter
                      :index="0"
                      :_this="context"
                      @resizestart="onResizePanel"
                      @onResize="onResizePanel"
                      @resizeend="onResizePanel"
                    ></SplitterGutter>

                    <!-- Chart container 2 -->
                    <SplitterPanel
                      class="row f-row quantity_height"
                      :size="chartSizes.sizeSplitterChart"
                      :minSize="4"
                      :style="`flex-basis: ${chartSizes.sizeSplitterChart}%`"
                    >
                      <div class="col col-12 quantity_chart_height">
                        <div class="row f-row h-100">
                          <div
                            class="col h-100"
                            v-bind:class="[
                              pickedAnalysis !== 1 ? 'col-3' : 'col-12',
                            ]"
                          >
                            <!-- Row: Chart Title -->
                            <div class="row f-row">
                              <div
                                class="chart-title-results text-left d-flex bdr-b"
                                v-if="pickedAnalysis !== 1"
                              >
                                Summary (<span
                                  style="color: var(--textactive)"
                                  >{{ currencyUnits.foreign }}</span
                                >):
                                <span class="ml-1">{{ riskProfile }}</span>
                                <img
                                  :src="portRisk"
                                  height="14px"
                                  alt=""
                                  style="padding: 2px 0 2px 5px;"
                                />
                              </div>
                              <div
                                class="chart-title-results text-left d-flex bdr-b"
                                v-else
                              >
                                <span class="mr-auto">
                                  Historical notional (<span
                                    style="color: var(--textactive)"
                                    >{{ currencyUnits.foreign }}</span
                                  >)
                                </span>
                                <div class="sidebarHidden">
                                  <button
                                    @click="onClientExpandSidebar"
                                    class="btn mr-1"
                                    style="width: 12px;"
                                  >
                                    <span v-if="expandAggregated">&#8594;</span>
                                    <i
                                      class="fa fa-compress"
                                      v-if="!expandAggregated"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!-- Row: Chart Selectors -->
                            <CurrencyPortfolioSelectors
                              v-if="pickedAnalysis !== 1"
                              :asset="'currencies'"
                              :showBasisRatio="showBasisRatio"
                              :showExpo="showExpo"
                              :showHedge="showHedge"
                              :showNet="showNet"
                              :showProgram="showProgram"
                              :showDetailExpo="showDetailExpo"
                              @eventOnShow="onShow"
                              @eventOnShowDetailExpo="onShowDetailExpo"
                              @eventOnShowProgram="onShowProgram"
                            />
                            <!-- Row: Chart -->
                            <CommodityPortfolioDetailChart
                              v-if="pickedAnalysis !== 1"
                              :chartData="detailExpoHedges"
                              :colorTheme="colorTheme"
                              :hedge="hedge"
                              :processData="processData"
                              :program="program"
                              :renderChartSignal="renderPortfolioSignal"
                              :showBasisRatio="showBasisRatio"
                              :showExpo="showExpo"
                              :showHedge="showHedge"
                              :showLoading="
                                showLoadingPort || showLoadingPortCalcs
                              "
                              :showProgram="showProgram"
                              :showTooltip="showTooltip"
                              :units="currencyUnits.foreign"
                              :zeroRequests="zeroRequests"
                            />

                            <div v-else class="row f-row h-100">
                              <div class="col col-1 h-100">
                                <PlanningSelectors
                                  :asset="'currencies'"
                                  :executeVolatility="true"
                                  :expandFRow="true"
                                  :isHorizontal="false"
                                  :normalizePlanning="normalizePlanning"
                                  :selectedExecutionTime="'week'"
                                  :showBudget="showExpo"
                                  :showBasisRatio="showBasisRatio"
                                  :showDates="false"
                                  :showExpo="showExpo"
                                  :showHedge="showHedge"
                                  :showProgram="showProgram"
                                  :showProtected="showHedge"
                                  :showRequired="false"
                                  :xRange="zoomPastXRange"
                                  :zoomFinal="zoomFinalPast"
                                  :zoomInitial="zoomInitialPast"
                                  @eventOnNormalizePlanning="
                                    onNormalizePlanning
                                  "
                                  @eventOnShow="onShowPast"
                                  @eventOnShowProgram="onShowProgram"
                                  @eventOnMinRange="eventMinRangePast"
                                  @eventOnMaxRange="eventMaxRangePast"
                                  @eventOnMinRangeChange="
                                    eventMinRangePastChange
                                  "
                                  @eventOnMaxRangeChange="
                                    eventMaxRangePastChange
                                  "
                                />
                              </div>
                              <div class="col col-11 h-100">
                                <PlanningChart
                                  :asset="'currencies'"
                                  :averages="pastAverages"
                                  :budgetRate="budgetRate"
                                  :chartData="pastChartsDataSliced"
                                  :colorTheme="colorTheme"
                                  :controlsSpace="false"
                                  :currency="currencyUnits"
                                  :dateFormat="dateFormatPast"
                                  :expandFRow="false"
                                  :isFuture="false"
                                  :normalizePlanning="normalizePlanning"
                                  :processData="processData"
                                  :renderChartSignal="renderPlanSignal"
                                  :showBasisRatio="showBasisRatio"
                                  :showBudget="showExpo"
                                  :showExpo="showExpo"
                                  :showHedge="showHedge"
                                  :showLoading="
                                    showLoadingTopography ||
                                      showLoadingTopographyCalcs
                                  "
                                  :showProgram="showProgram"
                                  :showProtected="showHedge"
                                  :showRequired="showRequired"
                                  :showTooltip="showTooltip"
                                  :zeroRequests="zeroRequests"
                                  @onTableFormat="onTableFormat"
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            class="col col-9 h-100 results-divider"
                            v-if="pickedAnalysis !== 1"
                          >
                            <!-- Row: Chart Title -->
                            <div class="row f-row">
                              <div
                                class="chart-title-results text-left d-flex bdr-b"
                              >
                                <span class="mr-auto">
                                  Quantities (<span
                                    style="color: var(--textactive)"
                                    >{{ currencyUnits.foreign }}</span
                                  >)
                                </span>
                                <div class="sidebarHidden">
                                  <button
                                    @click="onClientExpandSidebar"
                                    class="btn mr-1"
                                    style="width: 12px;"
                                  >
                                    <span v-if="expandAggregated">&#8594;</span>
                                    <i
                                      class="fa fa-compress"
                                      v-if="!expandAggregated"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!-- Row: Chart Selectors -->
                            <PlanningSelectors
                              v-if="pickedAnalysis !== 1"
                              :asset="'currencies'"
                              :expandFRow="true"
                              :normalizePlanning="normalizePlanning"
                              :selectedExecutionTime="selectedExecutionTime"
                              :showBasisRatio="showBasisRatio"
                              :showBudget="showExpo"
                              :showDates="false"
                              :showExpo="showExpo"
                              :showHedge="showHedge"
                              :showProgram="showProgram"
                              :showProtected="showHedge"
                              :showRequired="showRequired"
                              :xRange="xRange"
                              :zoomFinal="zoomFinal"
                              :zoomInitial="zoomInitial"
                              @eventOnShow="onShow"
                              @eventOnShowRequired="onShowRequired"
                              @eventOnShowProgram="onShowProgram"
                              @eventOnNormalizePlanning="onNormalizePlanning"
                              @eventOnMinRange="eventMinRange"
                              @eventOnMaxRange="eventMaxRange"
                              @eventOnUserSelectedExecutionTime="
                                onUserSelectedExecutionTime
                              "
                            />
                            <!-- Row: Chart -->
                            <PlanningChart
                              v-if="pickedAnalysis !== 1"
                              :asset="'currencies'"
                              :averages="averages"
                              :budgetRate="budgetRate"
                              :chartData="chartsDataSliced"
                              :colorTheme="colorTheme"
                              :currency="currencyUnits"
                              :dateFormat="dateFormat"
                              :expandFRow="false"
                              :isFuture="true"
                              :normalizePlanning="normalizePlanning"
                              :processData="processData"
                              :renderChartSignal="renderPlanSignal"
                              :showBasisRatio="showBasisRatio"
                              :showBudget="showExpo"
                              :showExpo="showExpo"
                              :showHedge="showHedge"
                              :showLoading="
                                showLoadingTopography ||
                                  showLoadingTopographyCalcs
                              "
                              :showProgram="showProgram"
                              :showProtected="showHedge"
                              :showRequired="showRequired"
                              :showTooltip="showTooltip"
                              :zeroRequests="zeroRequests"
                              @onTableFormat="onTableFormat"
                            />
                          </div>
                        </div>
                      </div>
                    </SplitterPanel>
                    <SplitterGutter
                      :index="1"
                      :_this="context"
                      @resizestart="onResizePanel"
                      @onResize="onResizePanel"
                      @resizeend="onResizePanel"
                      :eventElement="newEventElement"
                      :eventParentElement="eventParentElement"
                    >
                    </SplitterGutter>

                    <!-- Chart container 3 -->
                    <SplitterPanel
                      class="row f-row table_height"
                      :size="chartSizes.sizeSplitterTable"
                      :minSize="4"
                      :style="`flex-basis: ${chartSizes.sizeSplitterTable}%`"
                    >
                      <div v-if="pickedAnalysis === 1" class="col col-12 h-100">
                        <!-- Table title -->
                        <div class="row f-row">
                          <div
                            class="chart-title-results text-left d-flex bdr-b"
                          >
                            <span
                              class="mr-auto"
                              :style="{
                                color:
                                  pickedAnalysis === 1
                                    ? 'var(--textative)'
                                    : 'var(--darkbackground2)',
                              }"
                            >
                              {{
                                pickedAnalysis !== 1
                                  ? "Data"
                                  : "Consolidated data"
                              }}
                            </span>
                            <div
                              class="sidebarHidden"
                              v-show="pickedAnalysis === 1"
                            >
                              <button
                                @click="onClientExpandSidebar"
                                class="btn mr-1"
                                style="width: 12px;"
                              >
                                <span v-if="expandAggregated">&#8594;</span>
                                <i
                                  class="fa fa-compress"
                                  v-if="!expandAggregated"
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- Table -->
                        <CommodityAdvancedTable
                          v-if="pickedAnalysis === 1"
                          :Analytics="Analytics"
                          :colorTheme="colorTheme"
                          :divName="'CommodityQty2'"
                          :formatVar="userHovered.userHovered"
                          :isLarge="true"
                          :isPast="true"
                          :isTotals="false"
                          :loadingAll="showLoadingAll"
                          :noDataStr="noDataStr"
                          :renderChartSignal="renderPlanSignal"
                          :showDetails="showDetails"
                          :sUnit="sUnit"
                          :tableFormat="infoTable"
                          :unit="unit"
                          :zoomedData="pastChartsDataSliced"
                        />
                      </div>
                      <div
                        class="col col-12 h-100"
                        v-show="pickedAnalysis !== 1"
                      >
                        <!-- Table title -->
                        <div class="row f-row">
                          <div
                            class="chart-title-results text-left d-flex bdr-b"
                          >
                            <span class="mr-auto">
                              Consolidated data
                            </span>
                            <div
                              class="sidebarHidden"
                              v-show="pickedAnalysis !== 1"
                            >
                              <button
                                @click="onClientExpandSidebar"
                                class="btn mr-1"
                                style="width: 12px;"
                              >
                                <span v-if="expandAggregated">&#8594;</span>
                                <i
                                  class="fa fa-compress"
                                  v-if="!expandAggregated"
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- Table -->
                        <CommodityAdvancedTable
                          v-if="pickedAnalysis !== 1"
                          :Analytics="Analytics"
                          :colorTheme="colorTheme"
                          :divName="'scenarios'"
                          :formatVar="userHovered.userHovered"
                          :isLarge="true"
                          :isPast="false"
                          :isTotals="false"
                          :loadingAll="showLoadingAll"
                          :noDataStr="noDataStr"
                          :renderChartSignal="renderPlanSignal"
                          :showDetails="showDetails"
                          :sUnit="sUnit"
                          :tableFormat="infoTable"
                          :unit="unit"
                          :zoomedData="chartsDataSliced"
                        />
                      </div>
                    </SplitterPanel>
                  </Splitter>

                  <!-- Right Panel -->
                  <div
                    class="col col-3 results-divider"
                    v-if="expandAggregated"
                  >
                    <!-- Aggregates title -->
                    <div class="row f-row">
                      <div class="chart-title-results text-left d-flex bdr-b">
                        Aggregates
                        <div class="ml-auto sidebarHidden">
                          <button
                            @click="onClientExpandSidebar"
                            class="btn mr-1"
                            style="width: 12px;"
                          >
                            <span v-if="expandAggregated">&#8594;</span>
                            <i
                              class="fa fa-compress"
                              v-if="!expandAggregated"
                            ></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Aggregates table -->
                    <div>
                      <CommodityAdvancedTable
                        :Analytics="Analytics"
                        :colorTheme="colorTheme"
                        :divName="
                          pickedAnalysis === 1 ? 'CommodityQty2' : 'scenarios'
                        "
                        :formatVar="userHovered.userHovered"
                        :isLarge="false"
                        :isPast="true"
                        :isTotals="true"
                        :loadingAll="showLoadingAll"
                        :noDataStr="noDataStr"
                        :renderChartSignal="renderPlanSignal"
                        :showDetails="showDetails"
                        :tableFormat="infoTable"
                        :zoomedData="
                          pickedAnalysis === 1
                            ? [pastAverages]
                            : [chartDataTotals]
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdvancedSelectors from "@/components/advanced/AdvancedSelectors.vue";
import CommodityAdvancedTable from "@/components/advanced/CommodityAdvancedTable.vue";
import CommodityPortfolioDetailChart from "@/components/advanced/CommodityPortfolioDetailChart.vue";
import CurrencyPortfolioSelectors from "@/components/advanced/CurrencyPortfolioSelectors.vue";
import HistoricalChart from "@/components/advanced/HistoricalChart.vue";
import LeftSidebarAdvancedCom from "@/components/advanced/LeftSidebarAdvancedCom.vue";
import PlanningChart from "@/components/advanced/PlanningChart.vue";
import PlanningSelectors from "@/components/advanced/PlanningSelectors.vue";
import RatesChart from "@/components/advanced/RatesChart.vue";
import RatesChartSelectors from "@/components/advanced/RatesChartSelectors.vue";
import Splitter from "@/components/splitter/Splitter.vue";
import SplitterPanel from "@/components/splitter/SplitterPanel.vue";
import SplitterGutter from "@/components/splitter/SplitterGutter.vue";
import { select, selectAll } from "d3";
import { formatDate_DDMMMYHMS } from "@/_core/_helpers/_helpers";
import { getAnalyticsCurrency } from "@/_core/data/api_calls/getAnalyticsCurrency";
import { getCandleData } from "@/_core/data/api_calls/getCandleData";
import { postAdvancedCurrencyUpdate } from "@/_core/data/api_calls/post_analytics_currency_update";
import { postAnalyticsCurrencySimulate } from "@/_core/data/api_calls/postAnalyticsCurrencySimulate";
import { getVolatilityIrregular } from "@/_core/data/APICalls";
import {
  calculateExpoHedgesCommodity,
  createChartsDataRaw,
  dataCompressAveragesCurrency,
  dataCompressCurrency,
  dataCompressCurrencySims,
  // defaultProgram,
  getAssets,
  getLatestHedges,
  getPortfolios,
  includeSimulations,
  minMaxYAxisRatesCalc,
  minMaxYAxisRatesPastCalc,
  pastDataCompressAveragesCurrency,
  renderTopographyCharts,
  resetHistoricalOHLC,
  sliceMinMaxRenderHistorical,
  sliceRenderAccum,
  spotFromFutHedge,
  timeCompare,
  zoomOnRangeSlider,
  zoomOnRangeSliderPast,
} from "@/_core/data/Advanced";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import {
  bucketNames,
  colorExpo,
  colorExpoAlpha4,
  colorFwd,
  colorFwdAlpha2,
  colorHedge,
  colorHedgeAlpha,
  colorNet,
  colorNetAlpha2,
  colorProgram,
  colorProgramAlpha,
  currencyFormat3,
  currencyFormat4,
  darkFwdF,
  darkFwdAlpha2,
  formatM,
  tIntervalsAnalytics,
  titleTexts,
  whiteGray,
  whiteGrayAlpha3,
} from "@/_core/_helpers/_parametric_tools";

export default {
  name: "Currency",
  components: {
    AdvancedSelectors,
    CommodityAdvancedTable,
    CommodityPortfolioDetailChart,
    CurrencyPortfolioSelectors,
    HistoricalChart,
    LeftSidebarAdvancedCom,
    PlanningChart,
    PlanningSelectors,
    RatesChart,
    RatesChartSelectors,
    Splitter,
    SplitterGutter,
    SplitterPanel,
  },
  props: {
    analytics_preferences: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
    companies: { required: true, default: [{ id: 0, company_name: "N.A." }] },
    countrySpecs: { required: true },
    currencySpecs: { required: true, default: () => [] },
    processData: { required: true },
    routePickedAnalysis: { required: false, type: Number, default: null },
  },
  data() {
    return {
      allDataRaw: [],
      assetReference: "currency",
      assets: [],
      averages: [],
      bucketTxt: "Week",
      budgetRate: 0,
      budgetUpdatedAt: "Waiting...",
      budgetUpToDate: false,
      chartsData: [],
      chartsDataRaw: [],
      chartsDataSliced: [],
      chartDataTotals: [],
      chartSizes: {
        sizeSplitterChartPrices: 37,
        sizeSplitterChart: 24.8,
        sizeSplitterTable: 38.2,
      },
      currencyNumber: -1,
      currencyString: "EURUSD",
      confidence: 67,
      context: {},
      contract: 0,
      dateFormat: null,
      dateFormatHist: null,
      dateFormatPast: "%b %y",
      derivativeAverages: [],
      derivativeAveragesPast: [],
      derivativeAveragesSliced: [],
      derivativeDateField: "hedged_date",
      detailExpoHedges: [],
      eventParentElement: null,
      expandSelectors: true,
      expandAggregated: false,
      expandSRow: false,
      expandTRow: false,
      expoDataRaw: [],
      expoDateField: "date",
      expoDateFieldByNum: { 0: "date", 1: "hedged_date" },
      expoDates: [
        { pk: 0, name: "Fixing" },
        { pk: 1, name: "Assigned" },
      ],
      faildGetHistoricalData: false,
      finalDate: new Date(),
      formatVars: [],
      hedge: 0,
      hedgeDataRaw: [],
      hedgeDataSliced: [],
      hedgeDateField: "hedged_date",
      hedgeDateFieldByNum: { 0: "date", 1: "hedged_date" },
      hedgeDates: [
        { pk: 0, name: "Fixing" },
        { pk: 1, name: "Assigned" },
      ],
      hedgingStats: {
        positive: 33.33,
        negative: 33.33,
        neutral: 33.34,
        posVal: 11,
        negVal: 11,
      },
      hideFRow: false,
      hideSRow: false,
      hideTRow: false,
      historicalData: [],
      historicalDataRaw: [{ open: null, high: null, low: null, close: null }],
      historicalDataRawM: [],
      historicalDataRawW: [],
      historicalDataSliced: [],
      historicalOHLC: { open: null, high: null, low: null, close: null },
      infoTable: [],
      initCurrencyDate: null,
      initialDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      isCents: 1,
      isCurrency: true,
      isInitial: false,
      lCall: require("@/assets/images/lCall.svg"),
      lCallOff: require("@/assets/images/derivUpOff.svg"),
      lCallOn: require("@/assets/images/lCall.svg"),
      lFwd: require("@/assets/images/lFwd.svg"),
      lFwdOff: require("@/assets/images/fwdUpOff.svg"),
      lFwdOn: require("@/assets/images/lFwd.svg"),
      lPut: require("@/assets/images/lPut.svg"),
      lPutOff: require("@/assets/images/derivUpOff.svg"),
      lPutOn: require("@/assets/images/lPut.svg"),
      minMaxYAxisFutureRates: [+Infinity, -Infinity],
      minMaxYAxisHistorical: [+Infinity, -Infinity],
      minMaxYAxisPast: [+Infinity, -Infinity],
      minMaxYAxisRates: [+Infinity, -Infinity],
      newEventElement: PointerEvent,
      normalizePlanning: false,
      onChangeScenarios: false,
      pastAverages: [],
      pastChartsDataD: [],
      pastChartsDataM: [],
      pastChartsDataRaw: [],
      pastChartsDataSliced: [],
      pastChartsDataW: [],
      pastData: [],
      pastExpoDataRaw: [],
      pastHedgeDataRaw: [],
      pastHedgeDataSliced: [],
      pastVolatility: { unhedged: 0, hedged: 0, net: 0 },
      pickedAnalysis: 2,
      pickedBucket: "1M",
      pickedGroupIntervalHistory: "week",
      pickedIntervalHistory: "1Y",
      pickedScenarioVal: "none",
      portfolioNumbers: [],
      portfolios: [],
      portRisk: require("@/assets/images/signal1.svg"),
      prevCurrencyNumber: -1,
      prevSpot: null,
      program: 0,
      programData: [],
      renderAccumSignal: 0,
      renderHistorical: 0,
      renderM2MSignal: 0,
      renderPlanSignal: 0,
      renderPortfolioSignal: 0,
      renderRateSignal: 0,
      riskProfile: "",
      sCall: require("@/assets/images/sCall.svg"),
      sCallOff: require("@/assets/images/derivDownOff.svg"),
      sCallOn: require("@/assets/images/sCall.svg"),
      selectedAsset: [],
      selectedChart: 0,
      selectedCompanies: [],
      selectedCompany: 0,
      selectedExecutionTime: "Week",
      selectedDerivativeDate: 1,
      selectedExpoDate: 1,
      selectedHedgeDate: 1,
      selectedPortfolios: [],
      sFwd: require("@/assets/images/sFwd.svg"),
      sFwdOff: require("@/assets/images/fwdDownOff.svg"),
      sFwdOn: require("@/assets/images/sFwd.svg"),
      showAccHedgeM2M: true,
      showAve: false,
      showBasisRatio: true,
      showBudget: true,
      showDerivatives: false,
      showDetailExpo: false,
      showDetails: false,
      showExpo: true,
      showHedge: true,
      showLCall: false,
      showLFwd: false,
      showLoadingAllData: false,
      showLoadingBudget: false,
      showLoadingFutExpo: false,
      showLoadingFutHedge: false,
      showLoadingHistCandles: false,
      showLoadingHistoricalRatesCalcs: false,
      showLoadingPastCalcs: false,
      showLoadingPastExpo: false,
      showLoadingPastHedge: false,
      showLoadingPortCalcs: false,
      showLoadingProgram: false,
      showLoadingSimulating: false,
      showLoadingSpot: false,
      showLoadingTopographyCalcs: false,
      showLoadingTopographyCalcsRates: false,
      showLoadingUpdateSpot: false,
      showLoadingValuating: false,
      showLoadingVolatility: false,
      showLPut: false,
      showMkt: true,
      showMonths: true,
      showNet: true,
      showProgram: true,
      showRequired: false,
      showSCall: false,
      showSFwd: false,
      showSimulations: false,
      showSPut: false,
      showTooltip: false,
      showTooltipDeriv: true,
      signal1: require("@/assets/images/signal1.svg"),
      signal2: require("@/assets/images/signal2.svg"),
      signal3: require("@/assets/images/signal3.svg"),
      signal4: require("@/assets/images/signal4.svg"),
      signal5: require("@/assets/images/signal5.svg"),
      simRate: null,
      simulationRequired: true,
      simulations: [],
      simulationsRaw: [],
      simulationsSliced: [],
      simUpToDate: false,
      smallCharts: false,
      spot: null,
      spotData: null,
      sPut: require("@/assets/images/sPut.svg"),
      sPutOff: require("@/assets/images/derivDownOff.svg"),
      sPutOn: require("@/assets/images/sPut.svg"),
      tableData: [],
      title: "WEEKLY",
      toBeFetched: true,
      toBeFetchedHidden: false,
      today: new Date(),
      totalExpoHedges: [],
      updatedAt: "Waiting...",
      userHovered: {
        userHovered: {
          date: "",
          variable: "",
          hovered: false,
          fromChart: false,
        },
      },
      valuationData: [],
      visibleLeft: false,
      xRange: [],
      zeroRequests: true,
      zoomFinal: 0,
      zoomFinalPast: 0,
      zoomInitial: 0,
      zoomInitialized: false,
      zoomInitialPast: 0,
      zoomPastInitialized: false,
      zoomPastXRange: [],
      isZoomY: true,
      isUpdatedRoute: false,
      itemsLeftSidebar: [],
      hasBootstrapped: false,
      isApplyingRoute: false,
      pendingRoute: null,
    };
  },
  created() {
    this.createFormatVars();
    document.title = "Advanced | Fx";
    this.pendingRoute = this.$route;
  },
  mounted() {
    this.bootstrapFromRoute();
    this.infoTableFct();
  },
  computed: {
    sUnit() {
      return this.selectedAsset === undefined
        ? null
        : this.selectedAsset[0] === undefined
        ? null
        : this.selectedAsset[0]?.currency_name.slice(3, 6);
    },
    unit() {
      return this.selectedAsset === undefined
        ? null
        : this.selectedAsset[0] === undefined
        ? null
        : this.selectedAsset[0]?.currency_name.slice(0, 3);
    },
    noDataStr() {
      return this.toBeFetched ? "Get Data" : "No Data Available";
    },
    Analytics() {
      return {
        assetType: "currency",
        userSelections: {
          fldBudget: "budget_rate",
          fldFixed: "hedge_rate",
          fldMkt: "m2m_rate",
          fldNet: "net_rate",
        },
      };
    },
    selectionStr() {
      if (this.isApplyingRoute) return;

      let comp =
        this.selectedCompanies.length === 1
          ? this.selectedCompanies[0].company_name
          : this.selectedCompanies.length + " COMPANIES";
      let port =
        this.selectedPortfolios.length === 1
          ? this.selectedPortfolios[0].name
          : this.selectedPortfolios.length + " PORTFOLIOS";
      let asset =
        this.selectedAsset.length === 1
          ? this.selectedAsset[0].product_name
          : this.selectedAsset.length > 1
          ? this.selectedAsset.length + "  CURRENCIES"
          : "N.A";
      return comp + " | " + port + " | " + asset;
    },
    currencyUnits() {
      return {
        foreign: this.currencyString.slice(0, 3),
        rate:
          this.currencyString.slice(0, 3) +
          "/" +
          this.currencyString.slice(3, 6),
        base: this.currencyString.slice(3, 6),
      };
    },
    showLoadingAll() {
      return (
        this.showLoadingHistCandles ||
        this.showLoadingSpot ||
        this.showLoadingUpdateSpot ||
        this.showLoadingFutExpo ||
        this.showLoadingPastExpo ||
        this.showLoadingFutHedge ||
        this.showLoadingPastHedge ||
        this.showLoadingProgram ||
        this.showLoadingBudget ||
        this.showLoadingPortCalcs ||
        this.showLoadingHistoricalRatesCalcs ||
        this.showLoadingTopographyCalcs ||
        this.showLoadingTopographyCalcsRates ||
        this.showLoadingPastCalcs ||
        this.showLoadingValuating ||
        this.showLoadingVolatility ||
        this.showLoadingSimulating
      );
    },
    showLoadingPort() {
      return (
        this.showLoadingFutExpo ||
        this.showLoadingFutHedge ||
        this.showLoadingProgram
      );
    },
    showLoadingTopography() {
      return (
        this.showLoadingFutExpo ||
        this.showLoadingFutHedge ||
        this.showLoadingSpot ||
        this.showLoadingBudget ||
        this.showLoadingProgram
      );
    },
    showLoadingPast() {
      return (
        this.showLoadingHistCandles ||
        this.showLoadingPastExpo ||
        this.showLoadingPastHedge ||
        this.showLoadingProgram
      );
    },
  },
  watch: {
    routePickedAnalysis(val) {
      if (val != null) {
        this.pickedAnalysis = val;
      }
    },
    $route: {
      handler(newRoute) {
        if (this.isUpdatedRoute) {
          this.isUpdatedRoute = false;
          return;
        }

        if (this.isApplyingRoute) return;

        this.validateAndApplyRouteParams(newRoute);
      },
      deep: true,
      immediate: false,
    },
    eventElement(newEvent) {
      const containerChartQty = select(".quantity-xl_height");
      const parentNode =
        containerChartQty.node() && containerChartQty.node().nextSibling;

      this.newEventElement = newEvent;
      this.eventParentElement = parentNode;
      this.onChangeScenarios = true;
    },
    chartSizes: {
      handler: "handleSplitterSizeChange",
      deep: true,
    },
    showLoadingSpot(val) {
      if (val === false) {
        this.prevSpot = this.spot;
        this.simRate = this.simRate == null ? this.spot : this.simRate;
      }
    },
    spot(val) {
      if (this.budgetRate == null) {
        this.budgetRate = val;
        this.budgetRate = val;
      }
    },
    showLoadingSimulating(val) {
      if (val === false) {
        dataCompressCurrencySims(
          this,
          this.simulationsRaw,
          this.pickedBucket,
          "simulations",
          "chartsData",
          this.isCents,
        );
        includeSimulations(this);
        zoomOnRangeSlider(this);
        renderTopographyCharts(this);
      }
    },
    showDerivatives(val) {
      this.showLFwd = val;
      this.showSFwd = val;
      this.showLCall = val;
      this.showSCall = val;
      this.showLPut = val;
      this.showSPut = val;
      // this.showAve = false;
      if (this.pickedAnalysis === 0) {
        this.onShow(-1);
      } else if (this.pickedAnalysis === 1) {
        this.onShowPast(-1);
      } else if (this.pickedAnalysis === 2) {
        this.onShow(-1);
      }
    },
    showLCall(val) {
      this.lCall = val === true ? this.lCallOn : this.lCallOff;
    },
    showSCall(val) {
      this.sCall = val === true ? this.sCallOn : this.sCallOff;
    },
    showLFwd(val) {
      this.lFwd = val === true ? this.lFwdOn : this.lFwdOff;
    },
    showSFwd(val) {
      this.sFwd = val === true ? this.sFwdOn : this.sFwdOff;
    },
    showLPut(val) {
      this.lPut = val === true ? this.lPutOn : this.lPutOff;
    },
    showSPut(val) {
      this.sPut = val === true ? this.sPutOn : this.sPutOff;
    },
    showLoadingPort(val) {
      if (val === false) {
        // if (this.programData.length === 0) {
        //   defaultProgram(this, "currencies");
        // }
        if (this.expoDataRaw.length === 0 && this.hedgeDataRaw.length === 0) {
          this.totalExpoHedges = [];
          this.detailExpoHedges = [];
          this.showLoadingPortCalcs = false;
          return;
        }
        calculateExpoHedgesCommodity(this);
        this.showLoadingPortCalcs = false;
        this.renderPortfolioSignal += 1;
      }
    },
    showLoadingTopography(val) {
      if (val === false) {
        this.afterLoadingTopography();
      }
    },
    showLoadingAllData(val) {
      if (val === false) {
        if (
          !this.allDataRaw ||
          this.allDataRaw.length === 0 ||
          this.allDataRaw[0] == null
        ) {
          this.resetLoadingNoData();
          return;
        }
        this.toBeFetchedHidden = true;
        this.createExpoHedgeVariables();
      }
    },
    showLoadingValuating(val) {
      if (val === false && this.hedgeDataRaw.length > 0) {
        createChartsDataRaw(
          this,
          "expoDataRaw",
          "hedgeDataRaw",
          "chartsDataRaw",
          true,
        );
        dataCompressCurrency(
          this,
          this.chartsDataRaw,
          this.pickedBucket,
          "chartsData",
          true,
          this.isCents,
        );
        dataCompressAveragesCurrency(
          this,
          this.hedgeDataRaw,
          this.pickedBucket,
          "derivativeAverages",
          "chartsData",
          this.chartsData[0].date,
        );
        includeSimulations(this);
        zoomOnRangeSlider(this);
        renderTopographyCharts(this);
      }
    },
    showLoadingHistCandles(val) {
      if (val === false) {
        this.historicalDataRaw = this.processData.includeSpotNew(
          this.historicalDataRaw,
          this.spotData,
        );
        this.historicalDataRawW = this.processData.ohlcNest(
          this.historicalDataRaw,
          "week",
        );
        this.historicalDataRawM = this.processData.ohlcNest(
          this.historicalDataRaw,
          "month",
        );
        sliceMinMaxRenderHistorical(this);
      }
    },
    showLoadingFutHedge(val) {
      if (val === false) {
        spotFromFutHedge(this, this.assetReference, "showLoadingSpot");
      }
    },
    showLoadingPast(val) {
      if (val === false) {
        this.afterLoadingPast();
        this.calculateVolatility(this.pastChartsDataSliced);
      }
    },
    showLoadingUpdateSpot(val) {
      if (val === false) {
        this.prevSpot = this.spot;
        resetHistoricalOHLC(this);
        sliceMinMaxRenderHistorical(this);
        this.simRate = this.simRate == null ? this.spot : this.simRate;
        if (this.hedgeDataRaw.length > 0) {
          postAdvancedCurrencyUpdate(
            this,
            this.allDataRaw[0].hedge,
            "showLoadingValuating",
          );
        }
      }
    },
    colorTheme() {
      this.renderPortfolioSignal += 1;
      this.renderPlanSignal += 1;
      this.infoTableFct();
    },
  },
  methods: {
    infoTableFct() {
      function hasNonNaNValue(arr, key) {
        return (arr || []).some(
          (obj) => obj && obj[key] != null && !Number.isNaN(Number(obj[key])),
        );
      }
      let infoT = [];
      // Price
      if (this.showMkt) {
        infoT.push(this.market("p"));
      }
      if (this.showExpo) {
        infoT.push(this.forecast("p"));
      }
      if (this.showHedge) {
        infoT.push(this.fixed("p"));
      }
      if (this.showNet) {
        infoT.push(this.net("p"));
      }
      // Derivatives
      const data = [
        ...(this.chartsData || []),
        ...(this.pastChartsData || []),
      ].filter(Boolean);
      if (this.showDerivatives) {
        if (hasNonNaNValue(data, "lFwd")) {
          infoT.push(this.lFwdFct("p"));
        }
        if (hasNonNaNValue(data, "sFwd")) {
          infoT.push(this.sFwdFct("p"));
        }
        if (hasNonNaNValue(data, "lCall")) {
          infoT.push(this.lCallFct("p"));
        }
        if (hasNonNaNValue(data, "lCallKO")) {
          infoT.push(this.lCallKOFct("p"));
        }
        if (hasNonNaNValue(data, "sCall")) {
          infoT.push(this.sCallFct("p"));
        }
        if (hasNonNaNValue(data, "sCallKO")) {
          infoT.push(this.sCallKOFct("p"));
        }
        if (hasNonNaNValue(data, "lPut")) {
          infoT.push(this.lPutFct("p"));
        }
        if (hasNonNaNValue(data, "lPutKO")) {
          infoT.push(this.lPutKOFct("p"));
        }
        if (hasNonNaNValue(data, "sPut")) {
          infoT.push(this.sPutFct("p"));
        }
        if (hasNonNaNValue(data, "sPutKO")) {
          infoT.push(this.sPutKOFct("p"));
        }
      }
      // Qty
      if (this.showExpo) {
        infoT.push(this.budget("q"));
        infoT.push(this.forecast("q"));
      }
      if (this.showBasisRatio) {
        infoT.push(this.ratio("q"));
      }
      if (this.showHedge) {
        infoT.push(this.fixed("q"));
      }
      // if (this.showHedge) {
      //   infoT.push(this.options("q"));
      // }
      if (this.showProgram) {
        infoT.push(this.programFct("q"));
      }
      // Difference
      infoT.push(this.difference("p"));
      infoT.push(this.differenceOne("p"));
      // infoT.push(this.differenceTwo("p"));
      // infoT.push(this.differenceThree("p"));
      Object.assign(this, { infoTable: infoT });
    },
    initiate() {
      this.isInitial = true;
      this.initCurrencyDate = new Date();
      this.initCurrencyDate.setFullYear(
        this.initCurrencyDate.getFullYear() - 10,
      );
      this.initCurrencyDate.setMonth(0);
      this.initCurrencyDate.setDate(1);
      this.initCurrencyDate.setHours(0);

      let _this = this;
      let i;
      let saveUserPref = false;
      let selComp = this.analytics_preferences.selected_company;
      this.selectedCompanies = [];
      if (selComp !== undefined) {
        for (i = 0; i < selComp.length; i++) {
          if (this.companies.find((d) => d === selComp[i]) !== undefined) {
            this.selectedCompanies.push(selComp[i]);
          }
        }
      }
      if (this.selectedCompanies.length === 0) {
        this.selectedCompanies.push(this.companies[0]);
        this.analytics_preferences.selected_company = this.selectedCompanies;
        this.$store.dispatch(
          "user_preferences/updateAnalyticsChoices",
          this.analytics_preferences,
        );
        saveUserPref = true;
      }
      // portfolios
      this.selectedPortfolios = [];
      this.portfolios = getPortfolios(
        this,
        this.assetReference,
        this.selectedCompanies,
      );
      if (this.portfolios.length === 0) {
        this.portfolioNumbers.push(0);
        this.currencyString = "EURUSD";
      } else {
        let selPort = this.analytics_preferences.selected_portfolio;
        this.selectedPortfolios = [];
        let idx;
        for (i = 0; i < selPort.length; i++) {
          idx = this.portfolios.findIndex(
            (d) =>
              d.name === selPort[i].name ||
              d.name === selPort[i].portfolio_name,
          );
          if (idx > -1) {
            this.selectedPortfolios.push(this.portfolios[idx]);
          }
        }
        if (this.selectedPortfolios.length === 0) {
          this.selectedPortfolios.push(this.portfolios[0]);
          this.analytics_preferences.selected_portfolio = this.selectedPortfolios;
          this.$store.dispatch(
            "user_preferences/updateAnalyticsChoices",
            this.analytics_preferences,
          );
          this.portfolioNumbers.push(this.selectedPortfolios[0].pk);
          saveUserPref = true;
        } else {
          this.selectedPortfolios.forEach(function(selectedPortfolio) {
            _this.portfolioNumbers.push(selectedPortfolio.pk);
          });
        }
        // ==== Currencies - currency string
        saveUserPref = getAssets(this);
        // ==== Currencies - currency number
        this.currencyNumber = this.selectedAsset[0].pk_i_idcurrency;
        this.currencyString = this.selectedAsset[0].currency_name;
      }
      if (saveUserPref) {
        this.saveAllPreferences();
      }
      this.isInitial = false;
    },
    bootstrapFromRoute() {
      if (this.hasBootstrapped) return;

      this.hasBootstrapped = true;
      this.isApplyingRoute = true;

      this.initiate();

      this.$nextTick(() => {
        const routeToApply = this.pendingRoute || this.$route;
        this.validateAndApplyRouteParams(routeToApply);

        this.isApplyingRoute = false;
      });
    },
    createFormatVars() {
      this.formatVars = {
        budgetBColor: colorExpoAlpha4,
        budgetColor: colorExpo,
        fixBColor: colorFwdAlpha2,
        fixColor: colorFwd,
        hedgedBColor: darkFwdAlpha2,
        hedgedColor: darkFwdF,
        mktBColor: whiteGrayAlpha3,
        mktColor: whiteGray,
        netBColor: colorNetAlpha2,
        netColor: colorNet,
        programBColor: colorProgramAlpha,
        programColor: colorProgram,
        ratioBColor: colorHedgeAlpha,
        ratioColor: colorHedge,
      };
    },
    budget(pOrQ) {
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["budgetBColor"](this.colorTheme),
        colorBdr: this.formatVars["budgetColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: pOrQ === "p" ? "budget_rate" : "cash_flow",
        elementNameTable: pOrQ === "p" ? "" : "PLANBudg",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Budget",
        nameData: pOrQ === "p" ? "budget_rate" : "budget_expo",
        sUnit: this.sUnit,
        unit: this.unit,
        unitPerc: pOrQ === "p" ? "budgetPPerc" : "budgetQPerc",
      });
    },
    forecast(pOrQ) {
      return this.getConfig({
        addLabel: false,
        colorBckTable: this.formatVars["budgetBColor"](this.colorTheme),
        colorBdr: this.isPrices ? "var(--expo)" : "var(--symmetry)",
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: pOrQ === "p" ? "budget_rate" : "cash_flow",
        elementNameTable: pOrQ === "p" ? "RATEB" : "PLANCF",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Reforecast",
        nameData: pOrQ === "p" ? "budget_rate" : "cash_flow",
        sUnit: this.sUnit,
        unit: this.unit,
        unitPerc: "-",
      });
    },
    ratio(pOrQ) {
      const label_txt =
        this.assetReference != "commodity"
          ? "Recognized"
          : this.fixing_type === "basis"
          ? "Basis"
          : this.fixing_type === "ratio"
          ? "Ratio"
          : this.fixing_type === "price"
          ? "Ratio"
          : "Premium";
      return this.getConfig({
        colorBckTable: this.formatVars["ratioBColor"](this.colorTheme),
        colorBdr: this.formatVars["ratioColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: pOrQ === "p" ? "budget_rate" : "balance",
        elementNameTable: pOrQ === "q" ? "PLANB" : "",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: label_txt,
        nameData: pOrQ === "p" ? "budget_rate" : "cash_flow",
        sUnit: this.sUnit,
        unit: this.unit,
        unitPerc: pOrQ === "p" ? "ratioPPerc" : "ratioQPerc",
      });
    },
    market(pOrQ) {
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["mktBColor"](this.colorTheme),
        colorBdr: "var(--whiteGray)",
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: pOrQ === "p" ? "m2m_rate" : "",
        elementNameTable: pOrQ === "p" ? "RATEE" : "",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Mkt",
        nameData: pOrQ === "p" ? "m2m_rate" : "",
        sUnit: this.sUnit,
        unit: this.unit,
        unitPerc: pOrQ === "p" ? "marketPPerc" : "marketPPerc",
      });
    },
    fixed(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: this.formatVars["fixBColor"](this.colorTheme),
          colorBdr: this.formatVars["fixColor"],
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "hedge_rate" : "hedge",
          elementNameTable: pOrQ === "p" ? "RATEH" : "PLANH",
          figureElements: "stackedBar1",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Hedged", // pOrQ === "p" ? "Hedged" : "hedged",
          nameData: pOrQ === "p" ? "hedge_rate" : "hedge",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: pOrQ === "p" ? "fixedPPerc" : "hedgedQPerc",
        }),
      };
    },
    options(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: this.formatVars["hedgedBColor"](this.colorTheme),
          colorBdr: this.formatVars["hedgedColor"](this.colorTheme),
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "" : "protected",
          elementNameTable: pOrQ === "p" ? "" : "PLANOP",
          figureElements: "stackedBar2",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Options",
          nameData: pOrQ === "p" ? "" : "protected",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: pOrQ === "p" ? "" : "protectedQPerc",
        }),
      };
    },
    programFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: this.formatVars["programBColor"](this.colorTheme),
          colorBdr: this.formatVars["programColor"](this.colorTheme),
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "" : "program",
          elementNameTable: pOrQ === "p" ? "" : "PLANProg",
          figureElements: "stacked1Bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Program",
          nameData: pOrQ === "p" ? "" : "program",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: pOrQ === "p" ? "" : "programQPerc",
        }),
      };
    },
    net(pOrQ) {
      return this.getConfig({
        addLabel: true,
        colorBckTable: this.formatVars["netBColor"](this.colorTheme),
        colorBdr: this.formatVars["netColor"](this.colorTheme),
        divP: pOrQ === "p",
        divQ: pOrQ === "q",
        elementName: pOrQ === "p" ? "net_rate" : "hedge",
        elementNameTable: pOrQ === "p" ? "RATEN" : "",
        figureElements: "bar",
        format: pOrQ === "p" ? currencyFormat3 : formatM,
        isCurrency: this.isCurrency,
        isDetails: false,
        isPrices: pOrQ === "p",
        label: "Net",
        nameData: pOrQ === "p" ? "net_rate" : "hedge",
        sUnit: this.sUnit,
        unit: this.unit,
        unitPerc: pOrQ === "p" ? "netPPerc" : "netQPerc",
      });
    },
    hedged() {
      return {
        ...this.getConfig({
          addLabel: true,
          label: "Options",
          colorBdr: "var(--net_2)",
          show: "showFixedFutures",
          typeFigure: { nameFigure: "twoStackedBars", toZero: true },
          figureDetails: null,
          xOffsetLeft: +2,
          showText: true,
          figureElements: "stacked2Bar",
          colorBckTable: "var(--net-alpha-2)",
        }),
        twoStackedBar: "q_hedged",
        customYFieldsText: [`q_fixed`, `q_hedged`],
      };
    },
    difference(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["mktBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "difference" : "difference",
          elementNameTable: "diff",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: null,
          label: "Net - Mkt",
          nameData: pOrQ === "p" ? "difference" : "difference",
          sUnit: this.sUnit,
          unit: "",
          unitPerc: pOrQ === "p" ? "difference" : "difference",
        }),
      };
    },
    differenceOne(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["mktBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "differenceOne" : "differenceOne",
          elementNameTable: "diffOne",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: null,
          label: "Hedge P&L",
          nameData: pOrQ === "p" ? "differenceOne" : "differenceOne",
          sUnit: this.sUnit,
          unit: "",
          unitPerc: pOrQ === "p" ? "differenceOne" : "differenceOne",
        }),
      };
    },
    differenceTwo(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["mktBColor"](this.colorTheme),
          colorBdr: "var(--whiteGray)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "differenceTwo" : "differenceTwo",
          elementNameTable: "diffTwo",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Open Exposure",
          nameData: pOrQ === "p" ? "differenceTwo" : "differenceTwo",
          sUnit: "",
          unit: "",
          unitPerc: pOrQ === "p" ? "differenceTwo" : "differenceTwo",
        }),
      };
    },
    differenceThree(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: this.formatVars["budgetBColor"](this.colorTheme),
          colorBdr: this.isPrices ? "var(--expo)" : "var(--symmetry)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: pOrQ === "p" ? "differenceThree" : "differenceThree",
          elementNameTable: "diffThree",
          figureElements: "bar",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isDetails: false,
          isPrices: pOrQ === "p",
          label: "Net - Budget",
          nameData: pOrQ === "p" ? "differenceThree" : "differenceThree",
          sUnit: "",
          unit: "",
          unitPerc: pOrQ === "p" ? "differenceThree" : "differenceThree",
        }),
      };
    },
    lFwdFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: "var(--fwd-alpha-2)",
          colorBdr: "var(--fwd)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "lFwd",
          elementNameTable: "DLF",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "+Fwd/Fut",
          nameData: "lFwd",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
        }),
      };
    },
    sFwdFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: "var(--dark-fwd-alpha-2)",
          colorBdr: "var(--dark-fwd)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "sFwd",
          elementNameTable: "DSF",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "-Fwd/Fut",
          nameData: "sFwd",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
        }),
      };
    },
    lCallFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: "var(--call-alpha-2)",
          colorBdr: "var(--call)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "lCall",
          elementNameTable: "DLC",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "+Call",
          nameData: "lCall",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
        }),
      };
    },
    lCallKOFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: "var(--call-alpha-2)",
          colorBdr: "var(--call)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "lCallKO",
          elementNameTable: "lCallKO",
          format: pOrQ === "p" ? currencyFormat4 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "+Call KO",
          nameData: "lCallKO",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: "lCKo",
        }),
      };
    },
    sCallFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: "var(--dark-call-alpha-2)",
          colorBdr: "var(--dark-call)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "sCall",
          elementNameTable: "DSC",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "-Call",
          nameData: "sCall",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
        }),
      };
    },
    sCallKOFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: "var(--dark-call-alpha-2)",
          colorBdr: "var(--dark-call)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "sCallKO",
          elementNameTable: "sCallKO",
          format: pOrQ === "p" ? currencyFormat4 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "-Call KO",
          nameData: "sCallKO",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: "sCKo",
        }),
      };
    },
    lPutFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: "var(--put-alpha)",
          colorBdr: "var(--put)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "lPut",
          elementNameTable: "DLP",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "+Put",
          nameData: "lPut",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
        }),
      };
    },
    lPutKOFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: "var(--put-alpha)",
          colorBdr: "var(--put)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "lPutKO",
          elementNameTable: "lPutKO",
          format: pOrQ === "p" ? currencyFormat4 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "+Put KO",
          nameData: "lPutKO",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: "lPKo",
        }),
      };
    },
    sPutFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: false,
          colorBckTable: "var(--put-alpha)",
          colorBdr: "var(--put)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "sPut",
          elementNameTable: "DSP",
          format: pOrQ === "p" ? currencyFormat3 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "-Put",
          nameData: "sPut",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
        }),
      };
    },
    sPutKOFct(pOrQ) {
      return {
        ...this.getConfig({
          addLabel: true,
          colorBckTable: "var(--put-alpha)",
          colorBdr: "var(--put)",
          divP: pOrQ === "p",
          divQ: pOrQ === "q",
          elementName: "sPutKO",
          elementNameTable: "sPutKO",
          format: pOrQ === "p" ? currencyFormat4 : formatM,
          isCurrency: this.isCurrency,
          isPrices: pOrQ === "p",
          label: "-Put KO",
          nameData: "sPutKO",
          show: "showFixedFutures",
          sUnit: this.sUnit,
          unit: this.unit,
          unitPerc: "sPKo",
        }),
      };
    },
    getConfig({
      addLabel,
      colorBckTable,
      colorBdr,
      divP,
      elementName,
      figureElements,
      format,
      isCurrency,
      isDetails,
      isPrices,
      label,
      nameData,
      sUnit,
      unit,
      elementNameTable,
      unitPerc = "",
    }) {
      return {
        addLabel,
        colorBckTable,
        colorBdr,
        divP,
        elementName,
        elementNameTable,
        figureElements,
        format,
        isCurrency,
        isDetails,
        isPrices,
        label,
        nameData,
        sUnit,
        unit,
        unitPerc,
      };
    },
    onRestoreSizes() {
      this.sizeSplitters({ isRestore: true });
    },
    getCurrencyHistorical() {
      let _this = this;
      this.showLoadingHistCandles = true;
      getCandleData(this, "technical_analysis_historical", {
        currencyNumber: _this.currencyNumber,
      })
        .then((data) => {
          this["historicalDataRaw"] = data;
          this["historicalOHLC"] = JSON.parse(
            JSON.stringify(data[data.length - 1]),
          );
          this["historicalOHLC"].open = +this["historicalOHLC"].open;
          this["historicalOHLC"].high = +this["historicalOHLC"].high;
          this["historicalOHLC"].low = +this["historicalOHLC"].low;
          this["historicalOHLC"].close = +this["historicalOHLC"].close;
          this["showLoadingHistCandles"] = false;
          this.spot = this.spot ? this.spot : this["historicalOHLC"].close;
          this.simRate = this.spot;
          this.prevSpot = this.spot;
          this.renderHistorical += 1;
        })
        .catch(function(error) {
          _this["showLoadingHistCandles"] = false;
          _this["historicalDataRaw"] = [];
          console.error("getCandleData ", error);
        });
      this.prevCurrencyNumber = this.currencyNumber;
    },
    sizeSplitters({ isRestore = false }) {
      this.panels.forEach((panel) => {
        const el = panel.$el.className;
        const selectElement = select(`.${el.split(" ").join(".")}`);
        if (isRestore) {
          selectElement
            .style("height", `${panel.size}%`)
            .style(
              "flex-basis",
              `calc(${panel.size}% - ${(this.panels.length - 1) *
                this.context.gutterSize}px)`,
            );
        }
      });
      this.renderAccumSignal += 1;
      this.renderHistorical += 1;
      this.renderM2MSignal += 1;
      this.renderPlanSignal += 1;
      this.renderPortfolioSignal += 1;
      this.renderRateSignal += 1;
      // this.$emit("resizeCharts");
    },
    getClassChartQty() {
      this.chartSizes.sizeSplitterChartPrices = 37;
      this.chartSizes.sizeSplitterChart = 24.8;
      this.chartSizes.sizeSplitterTable = 38.2;
      return "quantity_height";
    },
    onResizePanel(value) {
      this.panels = value.panels;
      if (this.onChangeScenarios) {
        this.sizeSplitters({ isRestore: true });
      } else {
        this.sizeSplitters({});
      }
      this.onChangeScenarios = false;
    },
    onContext(context) {
      this.context = context;
    },
    getCommonQueryFilters() {
      const companies = this.selectedCompanies
        .filter((c) => c && c.company_name)
        .map((c) => c.company_name)
        .join(",");
      const portfolios = this.selectedPortfolios
        .filter((p) => p && p.name)
        .map((p) => p.name)
        .join(",");
      const currencies = this.selectedAsset
        .filter((a) => a && a.currency_name)
        .map((a) => a.currency_name)
        .join(",");

      return { companies, portfolios, currencies };
    },
    updateRoute() {
      if (this.isApplyingRoute) return;

      this.isUpdatedRoute = true;

      const routeName =
        this.pickedAnalysis === 1
          ? "advanced-historical-analysis"
          : "advanced-scenario-analysis";

      if (!routeName) {
        console.warn("No se pudo determinar el nombre de la ruta");
        return;
      }

      const query = this.getCommonQueryFilters();

      if (!query) {
        console.warn("No se pudieron obtener filtros válidos para valuation");
        return;
      }

      const routeConfig = {
        name: routeName,
        params: { productType: "currency" },
        query,
      };

      if (
        this.$route.name !== routeConfig.name ||
        JSON.stringify(this.$route.params) !==
          JSON.stringify(routeConfig.params) ||
        JSON.stringify(this.$route.query) !== JSON.stringify(routeConfig.query)
      ) {
        this.$router.push(routeConfig).catch((err) => {
          if (err.name !== "NavigationDuplicated") console.error(err);
        });
      }
    },
    validateAndApplyRouteParams(route) {
      const { query, name, params } = route;

      if (params && params.productType === "currency") {
        if (name === "advanced-historical-analysis") {
          this.selectedAnalysisParent = "historical-analysis";
          this.onClientAnalysisSelect(1);
        } else if (name === "advanced-scenario-analysis") {
          this.selectedAnalysisParent = "scenario-analysis";
          this.onClientAnalysisSelect(2);
        } else {
          this.updateRoute();
        }
      } else {
        this.isApplyingRoute = false;
        this.updateRoute();
        this.saveAllPreferences();
      }

      if (!query || !query.companies) return;
      const companyNames = query.companies.split(",");
      const validCompanies = this.companies.filter((c) =>
        companyNames.includes(c.company_name),
      );
      if (validCompanies.length === 0) return;

      // 1. Resolve portfolios using getPortfolios() which has the correct structure
      const portfolios = getPortfolios(this, "currency", validCompanies);
      let selectedPortfolios = portfolios.length > 0 ? [portfolios[0]] : [];
      if (query.portfolios && portfolios.length > 0) {
        const portNames = query.portfolios.split(",");
        const filtered = portfolios.filter((p) => portNames.includes(p.name));
        if (filtered.length > 0) selectedPortfolios = filtered;
      }

      // 2. Apply company + portfolio to state so getAssets() reads the right portfolio
      this.selectedCompanies = validCompanies;
      this.portfolios = portfolios;
      this.selectedPortfolios = selectedPortfolios;
      this.portfolioNumbers = selectedPortfolios.map((p) => p.pk);
      this.analytics_preferences.selected_company = validCompanies;
      this.analytics_preferences.selected_portfolio = selectedPortfolios;

      // 3. Re-load assets for the correct portfolios
      getAssets(this);

      // 4. Match currency in the freshly loaded this.assets
      if (query.currencies && this.assets && this.assets.length > 0) {
        const currencyNames = query.currencies.split(",");
        const filtered = this.assets.filter(
          (a) => a && currencyNames.includes(a.currency_name),
        );
        if (filtered.length > 0) {
          this.selectedAsset = filtered;
          this.currencyNumber = filtered[0].pk_i_idcurrency;
          this.currencyString = filtered[0].currency_name;
          this.analytics_preferences.selected_currencies = filtered;
        }
      }

      if (!this.shouldCallApi()) return;

      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        this.analytics_preferences,
      );
      this.renderAll();
      this.apiCalls();
      this.saveAllPreferences();
    },
    shouldCallApi() {
      return (
        this.selectedCompanies.length > 0 &&
        this.selectedPortfolios.length > 0 &&
        this.selectedAsset.length > 0
      );
    },
    onLeftSidebarAnalysisScenarios({ getEvent }) {
      this.eventElement = getEvent;
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.selectedAnalysisParent = parent;
      this.onClientAnalysisSelect(+val);
      setTimeout(() => {
        this.visibleLeft = false;
      }, 500);
    },
    onUserClickLeftSidebarShow(val) {
      this.visibleLeft = val;
    },
    saveAllPreferences() {
      this.analytics_preferences.selected_company = this.selectedCompanies;
      this.analytics_preferences.selected_portfolio = this.selectedPortfolios;
      this.analytics_preferences.selected_currencies = this.selectedAsset;
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        this.analytics_preferences,
      );
      saveUserPreferences(this);
    },
    onEmitValuation(val) {
      let _this = this;
      this.valuationData = [];
      let tot = 0;
      let idxOf;
      val.forEach(function(d, i) {
        idxOf = d.date.indexOf(":");
        _this.valuationData.splice(i, 0, {
          name: idxOf < 0 ? "" : d.date.substring(0, idxOf),
          date: idxOf < 0 ? d.date : d.date.substring(idxOf + 1),
          value: d.strategy_value,
        });
        if (i > 1) {
          tot += d.strategy_value;
        }
      });
      this.valuationData.push({ name: "ACTIVE", date: "TOTAL", value: tot });
    },
    onEmitTable(val) {
      let _this = this;
      this.tableData = [];
      val.forEach(function(d, i) {
        _this.tableData.splice(i, 0, d);
      });
    },
    afterLoadingPast() {
      if (
        this.pastExpoDataRaw.length === 0 &&
        this.pastHedgeDataRaw.length === 0
      ) {
        this.pastChartsDataSliced = [];
        this.showLoadingPastCalcs = false;
        return;
      }
      createChartsDataRaw(
        this,
        "pastExpoDataRaw",
        "pastHedgeDataRaw",
        "pastChartsDataRaw",
        false,
      );
      // Daily
      dataCompressCurrency(
        this,
        this.pastChartsDataRaw,
        "1D",
        "pastChartsDataD",
        false,
        this.isCents,
      );
      // Weekly
      dataCompressCurrency(
        this,
        this.pastChartsDataRaw,
        "1W",
        "pastChartsDataW",
        false,
        this.isCents,
      );
      // Monthly
      dataCompressCurrency(
        this,
        this.pastChartsDataRaw,
        "1M",
        "pastChartsDataM",
        false,
        this.isCents,
      );
      pastDataCompressAveragesCurrency(
        this,
        this.pastHedgeDataRaw,
        "1M",
        "derivativeAveragesPast",
        "pastChartsDataM",
      );
      zoomOnRangeSliderPast(this);
      sliceRenderAccum(this);
    },
    afterLoadingTopography() {
      if (this.budgetRate === 0) {
        this.budgetRate = this.spot;
        this.budgetUpToDate = false;
      }
      // if (this.programData.length === 0) {
      //   defaultProgram(this, "currencies");
      // }
      if (this.expoDataRaw.length === 0 && this.hedgeDataRaw.length === 0) {
        this.chartsDataSliced = [];
        this.showLoadingTopographyCalcs = false;
        this.showLoadingTopographyCalcsRates = false;
        return;
      }
      if (
        this.showLoadingHistCandles === false &&
        this.showLoadingHistoricalRatesCalcs === false
      ) {
        resetHistoricalOHLC(this);
        sliceMinMaxRenderHistorical(this);
      }
      this.finalDate = new Date();
      this.topographyCalculateAndFinish();

      zoomOnRangeSlider(this);
      renderTopographyCharts(this);
    },
    onUserZoomRates(val) {
      let sgn1 = val === 0 || val === 3 ? 1 : -1;
      let sgn2 = val === 0 || val === 2 ? -1 : 1;
      let delta = 0.1 * (this.minMaxYAxisRates[1] - this.minMaxYAxisRates[0]);
      this.minMaxYAxisRates = [
        this.minMaxYAxisRates[0] + sgn1 * delta,
        this.minMaxYAxisRates[1] + sgn2 * delta,
      ];
      this.renderRateSignal += 1;
      this.renderHistorical += 1;
    },
    onUserZoomPast(val) {
      let sgn1 = val === 0 || val === 3 ? 1 : -1;
      let sgn2 = val === 0 || val === 2 ? -1 : 1;
      let delta = 0.1 * (this.minMaxYAxisPast[1] - this.minMaxYAxisPast[0]);
      this.minMaxYAxisPast = [
        this.minMaxYAxisPast[0] + sgn1 * delta,
        this.minMaxYAxisPast[1] + sgn2 * delta,
      ];
      this.renderRateSignal += 1;
    },
    onUserSelectedDerivativeDate(val) {
      this.zoomInitialized = false;
      this.selectedDerivativeDate = val;
      this.derivativeDateField = this.hedgeDateFieldByNum[val];
      this.afterLoadingTopography();
      this.afterLoadingPast();
    },
    onUserSelectExpoDate(val) {
      this.zoomInitialized = false;
      this.selectedExpoDate = val;
      this.expoDateField = this.expoDateFieldByNum[val];
      this.afterLoadingTopography();
      this.afterLoadingPast();
    },
    onUserSelectHedgeDate(val) {
      this.zoomInitialized = false;
      this.selectedHedgeDate = val;
      this.hedgeDateField = this.hedgeDateFieldByNum[val];
      this.afterLoadingTopography();
      this.afterLoadingPast();
    },
    onChangeToBeFetched(val) {
      this.toBeFetched = val;
    },
    onUserFetchExpand(val) {
      this.toBeFetchedHidden = val;
      if (!val) {
        this.showSimulations = false;
      }
    },
    onPickedScenario(val) {
      this.pickedScenarioVal = val;
      if (val === "none") {
        this.onUserSpotChange(this.spot, true);
      } else {
        this.showLoadingValuating = true;
        let _this = this;
        let m2m_rate = val === "down" ? "percentiles_dn" : "percentiles_up";
        let expoSims = _this.simulationsRaw.filter((d) => d.is_expo);
        let pkx = expoSims.map((d) => d["pk"]).map(Number);
        let pk;
        this.allDataRaw[0].expo.forEach(function(d) {
          pk = pkx.indexOf(+d["pk"]);
          if (pk > -1) {
            if (!("fwd_original" in d)) {
              d["fwd_original"] = +d["fwd"];
            }
            d["fwd"] = expoSims[pk][m2m_rate];
          }
        });
        if (this.allDataRaw[0].hedge.length > 0) {
          let hedgeSims = _this.simulationsRaw.filter((d) => !d.is_expo);
          pkx = hedgeSims.map((d) => +d["pk"]);
          this.allDataRaw[0].hedge.forEach(function(d) {
            pk = pkx.indexOf(+d["pk"]);
            if (pk > -1) {
              if (!("fwd_original" in d)) {
                d["fwd_original"] = +d["fwd"];
              }
              d["fwd"] = hedgeSims[pk][m2m_rate];
            }
          });
        }
        postAdvancedCurrencyUpdate(
          this,
          this.allDataRaw[0].hedge,
          "showLoadingValuating",
        );
      }
    },
    onTableFormat(val) {
      Object.assign(this.userHovered, {
        userHovered: {
          date: val.date,
          variable: val.variable,
          hovered: val.hovered,
          fromChart: val.fromChart,
        },
      });
    },
    topographyCalculateAndFinish() {
      createChartsDataRaw(
        this,
        "expoDataRaw",
        "hedgeDataRaw",
        "chartsDataRaw",
        true,
      );
      dataCompressCurrency(
        this,
        this.chartsDataRaw,
        this.pickedBucket,
        "chartsData",
        true,
        this.isCents,
      );
      dataCompressAveragesCurrency(
        this,
        this.hedgeDataRaw,
        this.pickedBucket,
        "derivativeAverages",
        "chartsData",
        this.chartsData[0].date,
      );
      dataCompressCurrencySims(
        this,
        this.simulationsRaw,
        this.pickedBucket,
        "simulations",
        "chartsData",
        this.isCents,
      );
      includeSimulations(this);
      this.infoTableFct();
    },
    calculateVolatility(data) {
      if (data.length > 0) {
        let volData = data.map(function(d) {
          return {
            date: d.date,
            unhedged: d.m2m_rate,
            hedged: d.hedge_rate,
            net: d.net_rate,
          };
        });
        getVolatilityIrregular(
          this,
          volData,
          "pastVolatility",
          "showLoadingVolatility",
        );
      }
    },
    // ========== user interactions =========
    onUserSelectedExecutionTime(val) {
      this.selectedExecutionTime = val;
      getLatestHedges(this);
      this.renderPlanSignal += 1;
    },
    onClientShowMonths(val) {
      this.showMonths = val;
    },
    onClientShowDetails(val) {
      this.showDetails = val;
    },
    onClientShowSims(val) {
      // force Assigned Date
      let forceChange = false;
      if (this.selectedExpoDate != 1) {
        this.selectedExpoDate = 1;
        this.expoDateField = this.expoDateFieldByNum[1];
        forceChange = true;
      }
      if (this.selectedHedgeDate != 1) {
        this.selectedHedgeDate = 1;
        this.hedgeDateField = this.hedgeDateFieldByNum[1];
        forceChange = true;
      }
      if (forceChange) {
        this.onUserSelectedDerivativeDate(1);
      }
      this.showSimulations = val;
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      this.minMaxYAxisFutureRates = [+Infinity, -Infinity];
      minMaxYAxisRatesCalc(
        this,
        "minMaxYAxisFutureRates",
        "chartsDataSliced",
        "hedgeDataRaw",
        "hedgeDataSliced",
        "simulationsSliced",
      );
      this.minMaxYAxisRates = [
        Math.min(this.minMaxYAxisFutureRates[0], this.minMaxYAxisHistorical[0]),
        Math.max(this.minMaxYAxisFutureRates[1], this.minMaxYAxisHistorical[1]),
      ];
      this.renderHistorical += 1;
      this.renderRateSignal += 1;
      this.renderM2MSignal += 1;
    },
    onUserConfidence(val) {
      this.confidence = val;
      this.simUpToDate = false;
    },
    onUserSimRateChange(val) {
      this.simRate = val;
      this.simUpToDate = false;
    },
    onUserSimulate() {
      postAnalyticsCurrencySimulate(
        this,
        "simulationsRaw",
        "showLoadingSimulating",
      );
      this.simUpToDate = true;
    },
    onShow(val) {
      if (val === 0) {
        this.showAve = !this.showAve;
      } else if (val === 1 || val === 4) {
        this.showBudget = !this.showBudget;
        this.showExpo = !this.showExpo;
      } else if (val === 2 || val === 15) {
        this.showHedge = !this.showHedge;
      } else if (val === 3) {
        this.showNet = !this.showNet;
      } else if (val === 5) {
        this.showLFwd = !this.showLFwd;
      } else if (val === 6) {
        this.showSFwd = !this.showSFwd;
      } else if (val === 7) {
        this.showLCall = !this.showLCall;
      } else if (val === 8) {
        this.showSCall = !this.showSCall;
      } else if (val === 9) {
        this.showLPut = !this.showLPut;
      } else if (val === 10) {
        this.showSPut = !this.showSPut;
      } else if (val === 11) {
        this.showBasisRatio = !this.showBasisRatio;
      } else if (val === 12) {
        this.showMkt = !this.showMkt;
      }
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      this.minMaxYAxisFutureRates = [+Infinity, -Infinity];
      minMaxYAxisRatesCalc(
        this,
        "minMaxYAxisFutureRates",
        "chartsDataSliced",
        "hedgeDataRaw",
        "hedgeDataSliced",
        "simulationsSliced",
      );
      Object.assign(this, {
        minMaxYAxisRates: [
          Math.min(
            this.minMaxYAxisFutureRates[0],
            this.minMaxYAxisHistorical[0],
          ),
          Math.max(
            this.minMaxYAxisFutureRates[1],
            this.minMaxYAxisHistorical[1],
          ),
        ],
      });
      if (this.showLoadingHistCandles === false) {
        this.renderHistorical += 1;
      }
      this.infoTableFct();
      this.renderRateSignal += 1;
    },
    onShowPast(val) {
      if (val === 0) {
        this.showAve = !this.showAve;
      } else if (val === 1 || val === 4) {
        this.showBudget = !this.showBudget;
        this.showExpo = !this.showExpo;
      } else if (val === 2 || val === 15) {
        this.showHedge = !this.showHedge;
      } else if (val === 3) {
        this.showNet = !this.showNet;
      } else if (val === 5) {
        this.showLFwd = !this.showLFwd;
      } else if (val === 6) {
        this.showSFwd = !this.showSFwd;
      } else if (val === 7) {
        this.showLCall = !this.showLCall;
      } else if (val === 8) {
        this.showSCall = !this.showSCall;
      } else if (val === 9) {
        this.showLPut = !this.showLPut;
      } else if (val === 10) {
        this.showSPut = !this.showSPut;
      } else if (val === 11) {
        this.showBasisRatio = !this.showBasisRatio;
      } else if (val === 12) {
        this.showMkt = !this.showMkt;
      }
      this.minMaxYAxisPast = [+Infinity, -Infinity];
      minMaxYAxisRatesPastCalc(
        this,
        "minMaxYAxisPast",
        "pastChartsDataSliced",
        "pastHedgeDataRaw",
        "historicalDataSliced",
        "pastHedgeDataSliced",
      );
      this.renderRateSignal += 1;
      this.renderPlanSignal += 1;
      this.infoTableFct();
      this.renderM2MSignal += 1;
    },
    onShowDerivatives() {
      this.showDerivatives = !this.showDerivatives;
      if (this.showDerivatives) {
        this.onShow(-10);
      }
      this.infoTableFct();
    },
    onShowDetailExpo() {
      this.showDetailExpo = !this.showDetailExpo;
    },
    onShowProgram() {
      this.showProgram = !this.showProgram;
      this.infoTableFct();
    },
    onShowRequired() {
      this.showRequired = !this.showRequired;
    },
    onNormalizePlanning() {
      this.normalizePlanning = !this.normalizePlanning;
    },
    onShowAccHedgeM2M() {
      this.showAccHedgeM2M = !this.showAccHedgeM2M;
    },
    onSelectChart() {
      this.selectedChart = 1 - this.selectedChart;
      this.renderM2MSignal += 1;
    },
    onShowTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    onShowTooltipDeriv() {
      this.showTooltipDeriv = !this.showTooltipDeriv;
    },
    onClientExpandSelectors(val) {
      this.expandSelectors = val;
    },
    onUserBudgetChange(val) {
      this.budgetRate = val;
      this.budgetUpToDate = false;
      this.budgetUpdatedAt =
        "Updated by user at: " + formatDate_DDMMMYHMS(new Date());
      this.renderRateSignal += 1;
    },
    // updateBudgetMethod() {
    //   // this.showLoadingBudget = true;
    //   getCommodityBudgetData(
    //     this,
    //     "budgetRate",
    //     "budgetUpdatedAt",
    //     "showLoadingBudget",
    //     "budgetUpToDate"
    //   );
    // },
    onUserBudgetUpdatedAtChange(val) {
      this.budgetUpdatedAt = val;
      this.budgetUpToDate = true;
      this.showLoadingBudget = false;
    },
    eventMinRange(val) {
      this.zoomInitial = val;
      zoomOnRangeSlider(this);
      renderTopographyCharts(this);
      calculateExpoHedgesCommodity(this);
      this.renderPortfolioSignal += 1;
    },
    eventMaxRange(val) {
      this.zoomFinal = val;
      zoomOnRangeSlider(this);
      renderTopographyCharts(this);
      calculateExpoHedgesCommodity(this);
      this.renderPortfolioSignal += 1;
    },
    eventMinRangePast(val) {
      this.showLoadingVolatility = true;
      this.zoomInitialPast = val;
      zoomOnRangeSliderPast(this);
      this.renderRateSignal += 1;
      this.renderPlanSignal += 1;
      this.renderM2MSignal += 1;
    },
    eventMaxRangePast(val) {
      this.showLoadingVolatility = true;
      this.zoomFinalPast = val;
      zoomOnRangeSliderPast(this);
      this.renderRateSignal += 1;
      this.renderPlanSignal += 1;
      this.renderM2MSignal += 1;
    },
    eventMinRangePastChange(val) {
      this.calculateVolatility(
        this.pastChartsDataM.slice(val, this.zoomFinalPast + 1),
      );
    },
    eventMaxRangePastChange(val) {
      this.calculateVolatility(
        this.pastChartsDataM.slice(this.zoomInitialPast, val + 1),
      );
    },
    onChangeUserSelection(val) {
      this.clearData();

      this.assets = val["asset"];
      this.selectedAsset = val["selectedAsset"];
      this.currencyNumber = this.selectedAsset[0]?.pk_i_idcurrency;
      this.currencyString = this.selectedAsset[0]?.currency_name;
      this.selectedCompanies = val["company"];
      this.portfolios = val["portfolios"];
      this.selectedPortfolios = val["selectedPortfolios"];
      this.updateRoute();
      this.saveAllPreferences();
    },
    onUserSelection(val) {
      this.zeroRequests = false;
      let _this = this;
      this.zoomInitialized = false;
      this.pickedAnalysis = 0;
      this.clearData();

      this.finalDate = new Date();
      this.selectedCompanies = val["company"];
      this.portfolios = val["portfolios"];
      this.selectedPortfolios = val["selectedPortfolios"];
      this.assets = val["asset"];
      this.currencyNumber = this.selectedAsset[0].pk_i_idcurrency;
      this.currencyString = this.selectedAsset[0].currency_name;
      this.portfolioNumbers = [];
      this.selectedPortfolios.forEach(function(selectedPortfolio) {
        _this.portfolioNumbers.push(selectedPortfolio.pk);
      });

      this.renderAll();
      this.apiCalls();
      this.saveAllPreferences();
      this.updateRoute();
    },
    createExpoHedgeVariables() {
      let _this = this;
      let intervalGroup = this.pickedBucket;
      let today = timeCompare(
        this.today,
        intervalGroup,
        _this.allDataRaw[0].expo,
      );
      let expoDateField = this.expoDateField;
      this.expoDataRaw = this.allDataRaw[0].expo.filter(
        (d) =>
          timeCompare(
            d[expoDateField],
            intervalGroup,
            _this.allDataRaw[0].expo,
          ) >= today,
      );
      this.showLoadingFutExpo = false;
      this.pastExpoDataRaw = this.allDataRaw[0].expo.filter(
        (d) =>
          timeCompare(
            d[expoDateField],
            intervalGroup,
            _this.allDataRaw[0].expo,
          ) < today,
      );
      this.showLoadingPastExpo = false;

      let hedgeDateField = this.hedgeDateField;
      this.hedgeDataRaw = this.allDataRaw[0].hedge.filter(
        (d) =>
          timeCompare(
            d[hedgeDateField],
            intervalGroup,
            _this.allDataRaw[0].hedge,
          ) >= today,
      );
      this.showLoadingFutHedge = false;
      this.pastHedgeDataRaw = this.allDataRaw[0].hedge.filter(
        (d) =>
          timeCompare(
            d[hedgeDateField],
            intervalGroup,
            _this.allDataRaw[0].hedge,
          ) < today,
      );
      this.showLoadingPastHedge = false;
    },
    resetLoadingNoData() {
      this.showLoadingHistCandles = false;
      this.showLoadingTopographyCalcs = false;
      this.showLoadingTopographyCalcsRates = false;
      this.showLoadingPastCalcs = false;
      this.showLoadingFutExpo = false;
      this.showLoadingPastExpo = false;
      this.showLoadingFutHedge = false;
      this.showLoadingPortCalcs = false;
      this.showLoadingPastHedge = false;
      this.showLoadingSpot = false;
    },
    apiCalls() {
      this.finalDate = new Date();
      this.clearData();

      this.showLoadingHistCandles = true;
      this.showLoadingTopographyCalcs = true;
      this.showLoadingTopographyCalcsRates = true;
      this.showLoadingPastCalcs = true;
      this.showLoadingFutExpo = true;
      this.showLoadingPastExpo = true;
      this.showLoadingFutHedge = true;
      this.showLoadingPortCalcs = true;
      this.showLoadingPastHedge = true;
      this.showLoadingSpot = false;
      getAnalyticsCurrency(
        this,
        "allDataRaw",
        "showLoadingAllData",
        this.initCurrencyDate,
      );
      this.getCurrencyHistorical();
    },
    onClientAnalysisSelect(val) {
      if (val === 0) {
        this.showSimulations = false;
        this.pickedAnalysis = val;
        this.pickedGroupIntervalHistory =
          tIntervalsAnalytics[this.pickedIntervalHistory];
        this.onHistoricalIntervalChange(this.pickedIntervalHistory);
        this.title = titleTexts[this.pickedGroupIntervalHistory];
        if (this.hedgeDataRaw.length > 0) {
          postAdvancedCurrencyUpdate(
            this,
            this.allDataRaw[0].hedge,
            "showLoadingValuating",
          );
        }
      } else if (val === 1) {
        // this.showSimulations = false;
        this.pickedGroupIntervalHistory = "week";
        this.title = "WEEKLY";
        this.pickedAnalysis = val;
        sliceMinMaxRenderHistorical(this);
        this.minMaxYAxisPast = [+Infinity, -Infinity];
        minMaxYAxisRatesPastCalc(
          this,
          "minMaxYAxisPast",
          "pastChartsDataSliced",
          "pastHedgeDataRaw",
          "historicalDataSliced",
          "pastHedgeDataSliced",
        );
        sliceRenderAccum(this);
        for (let i = 0; i < 22; i++) {
          setTimeout(() => {
            this.renderRateSignal += 1;
            this.renderPlanSignal += 1;
            this.renderM2MSignal += 1;
          }, (i + 1) * 50);
        }
      } else if (val === 2) {
        // this.showSimulations = true;
        // this.toBeFetchedHidden = true;
        this.pickedAnalysis = val;
        this.pickedGroupIntervalHistory =
          tIntervalsAnalytics[this.pickedIntervalHistory];
        this.onHistoricalIntervalChange(this.pickedIntervalHistory);
        this.title = titleTexts[this.pickedGroupIntervalHistory];
        this.renderHistorical += 1;
      }
      this.updateRoute();
    },
    onUserSpotChange(val, resetFwd = false) {
      let _this = this;
      this.pickedScenarioVal = "none";
      this.spot = val;
      let delta = this.spot / this.prevSpot;
      this.prevSpot = this.spot;
      this.allDataRaw[0].expo.forEach(function(d) {
        if (Math.min(+d["hedged_date"], +d["date"]) > +_this.today) {
          if (resetFwd) {
            if ("fwd_original" in d) {
              d["fwd"] = d["fwd_original"];
            }
          } else {
            if (!("fwd_original" in d)) {
              d["fwd_original"] = +d["fwd"];
            }
            d["fwd"] *= delta;
          }
        }
      });
      this.updatedAt =
        "Defined by user at: " + formatDate_DDMMMYHMS(new Date());
      resetHistoricalOHLC(this);
      this.showLoadingValuating = true;
      sliceMinMaxRenderHistorical(this);
      if (this.allDataRaw[0].hedge.length > 0) {
        this.allDataRaw[0].hedge.forEach(function(d) {
          if (Math.min(+d["fixing_date"], +d["hedged_date"]) > +_this.today) {
            if (resetFwd) {
              if ("fwd_original" in d) {
                d["fwd"] = d["fwd_original"];
              }
            } else {
              if (!("fwd_original" in d)) {
                d["fwd_original"] = +d["fwd"];
              }
              d["fwd"] *= delta;
            }
          }
        });
        postAdvancedCurrencyUpdate(
          this,
          this.allDataRaw[0].hedge,
          "showLoadingValuating",
        );
      } else {
        this.showLoadingValuating = false;
        throw Error("No hedge data raw available");
      }
    },
    onHistoricalIntervalChange(interval) {
      this.minMaxYAxisFutureRates = [+Infinity, -Infinity];
      this.minMaxYAxisRates = [+Infinity, -Infinity];
      this.minMaxYAxisHistorical = [+Infinity, -Infinity];
      this.pickedIntervalHistory = interval;
      if (this.pickedAnalysis === 1) {
        this.pickedGroupIntervalHistory = "1M";
      } else {
        this.pickedGroupIntervalHistory = tIntervalsAnalytics[interval];
      }
      this.title = titleTexts[this.pickedGroupIntervalHistory];
      minMaxYAxisRatesCalc(
        this,
        "minMaxYAxisFutureRates",
        "chartsDataSliced",
        "hedgeDataRaw",
        "hedgeDataSliced",
        "simulationsSliced",
      );
      this.minMaxYAxisRates = [
        Math.min(this.minMaxYAxisFutureRates[0], this.minMaxYAxisHistorical[0]),
        Math.max(this.minMaxYAxisFutureRates[1], this.minMaxYAxisHistorical[1]),
      ];
      sliceMinMaxRenderHistorical(this);
      sliceRenderAccum(this);
    },
    onBucketChange(bucket) {
      this.zoomInitialized = false;
      this.pickedBucket = bucket;
      this.bucketTxt = bucketNames[bucket];
      dataCompressCurrency(
        this,
        this.chartsDataRaw,
        bucket,
        "chartsData",
        true,
        this.isCents,
      );
      dataCompressAveragesCurrency(
        this,
        this.hedgeDataRaw,
        this.pickedBucket,
        "derivativeAverages",
        "chartsData",
        this.chartsData[0].date,
      );
      dataCompressCurrencySims(
        this,
        this.simulationsRaw,
        this.pickedBucket,
        "simulations",
        "chartsData",
        this.isCents,
      );
      includeSimulations(this);
      zoomOnRangeSlider(this);
      renderTopographyCharts(this);
    },
    // ========== animations ==========
    renderAll() {
      this.renderPlanSignal += 1;
      this.renderPortfolioSignal += 1;
      this.renderHistorical += 1;
      this.renderRateSignal += 1;
      this.renderAccumSignal += 1;
      this.renderM2MSignal += 1;
    },
    deleteAll() {
      select("#svg-bars_portfolio")
        .select("svg > *")
        .remove();
      select("#svg-bars_detail")
        .select("svg > *")
        .remove();
      select("#svg-planning")
        .select("svg > *")
        .remove();
      select("#svg-candles")
        .select("svg > *")
        .remove();
      select("#svg-rates")
        .select("svg > *")
        .remove();
      select("#svg-accum")
        .select("svg > *")
        .remove();
      select("#svg-m2m_fut")
        .select("svg > *")
        .remove();
    },
    onClientExpandSidebar() {
      if (this.expandAggregated) {
        this.expandAggregated = false;
        for (let i = 0; i < 12; i++) {
          setTimeout(() => {
            this.renderAll();
          }, (i + 1) * 50);
        }
      } else {
        this.expandAggregated = true;
        this.deleteAll();
        setTimeout(() => {
          this.renderAll();
        }, 200);
      }
    },
    clearData() {
      Object.assign(this, {
        allDataRaw: [],
        averages: [],
        chartsData: [],
        chartsDataRaw: [],
        chartsDataSliced: [],
        chartDataTotals: [],
        derivativeAverages: [],
        derivativeAveragesPast: [],
        derivativeAveragesSliced: [],
        detailExpoHedges: [],
        expoDataRaw: [],
        hedgeDataRaw: [],
        hedgeDataSliced: [],
        historicalData: [],
        historicalDataRaw: [{ open: null, high: null, low: null, close: null }],
        historicalDataRawM: [],
        historicalDataRawW: [],
        historicalDataSliced: [],
        historicalOHLC: { open: null, high: null, low: null, close: null },
        minMaxYAxisFutureRates: [+Infinity, -Infinity],
        minMaxYAxisHistorical: [+Infinity, -Infinity],
        minMaxYAxisPast: [+Infinity, -Infinity],
        minMaxYAxisRates: [+Infinity, -Infinity],
        pastAverages: [],
        pastChartsDataD: [],
        pastChartsDataM: [],
        pastChartsDataRaw: [],
        pastChartsDataSliced: [],
        pastChartsDataW: [],
        pastData: [],
        pastExpoDataRaw: [],
        pastHedgeDataRaw: [],
        pastHedgeDataSliced: [],
        pastVolatility: { unhedged: 0, hedged: 0, net: 0 },
        prevSpot: null,
        program: 0,
        programData: [],
        simRate: null,
        simulations: [],
        simulationsRaw: [],
        simulationsSliced: [],
        spot: null,
        spotData: null,
        totalExpoHedges: [],
      });
    },
  },
  beforeDestroy() {
    selectAll(".tooltip").remove();
  },
};
</script>

<style scoped>
.no_nav_height_no_title {
  height: calc(100vh - 133px) !important;
}

.p-splitter {
  border: 0;
  background: 0;
  border-radius: 0;
}

div.p-splitter .p-splitter-gutter {
  background: 0;
}
</style>
